var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('with-header',[_c('iframe',{staticClass:"editor",attrs:{"src":"./editor.html"}})])}
var staticRenderFns = []

export { render, staticRenderFns }